import { render, staticRenderFns } from "./sizeClean.vue?vue&type=template&id=1ce890ce&scoped=true"
import script from "./sizeClean.vue?vue&type=script&lang=js"
export * from "./sizeClean.vue?vue&type=script&lang=js"
import style0 from "./sizeClean.vue?vue&type=style&index=0&id=1ce890ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce890ce",
  null
  
)

export default component.exports